import { DataFieldArray } from './datafield-array';
import { DataFieldChoice } from './datafield-choice';
import { DataFieldType } from './datafield-type';

export class DataField {

    public DataFieldId: number;

    public DataType: DataFieldType;

    public DisplayName: string;

    public IsRequired: boolean;

    public SortOrder: number;


    public DataLength?: number;

    public DisplayLength?: number;

    public DefaultValue: any;

    public RegEx: string;

    public RegExErrorMessage: string;

    public InfoText: string;

    public CallbackReferenceId: string;

    public Choices: DataFieldChoice[];

    public Value: any;

    public SecretId?: string;

    public AdditionalInfo: string[];

    public DependsOnCallbackReferenceId: string;

    public DependsOnValues: string[];

    public IsHidden: boolean;

    /**
    * This field is used to have a unique identification of this datafield in case of the same datafield being shown multiple times - eg. multiple identical tracking-fields (used for validation).
    * This is a value that is only used in the frontend.
    */
    public UniqueId: string;

    public Array: DataFieldArray;

    private IsSecretMapped: boolean;

    public static RemapSecret(datafield: DataField): void {
        if (!datafield.IsSecretMapped) {
            datafield.IsSecretMapped = true;
            datafield.SecretId = datafield.Value;
            datafield.Value = '';
        }
    }
}
